import type React from "react";

export const ContactSection: React.FC = () => {
	return (
		<section id="contact-section" className="gw-card-section contact-section">
			<h2 className="text-lg">Have a question about your donation?</h2>
			<p>
				Email us at{" "}
				<strong>
					<a href="mailto:info@givewise.org.hk">info@givewise.org.hk</a>
				</strong>{" "}
				and we'll get back to you within one business day.
			</p>
		</section>
	);
};
